import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';

export const About = () => {
  return (
    <section id="chi-siamo" className="relative py-24 md:py-32 bg-gradient-to-b from-slate-50 to-white overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-100 rounded-full blur-3xl opacity-20 -z-0"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex flex-col gap-3 mb-8">
              <div className="h-px w-12 bg-amber-600"></div>
              <p className="text-amber-600 text-sm font-semibold tracking-[0.3em] uppercase">
                Chi Siamo
              </p>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-8 leading-tight" 
                style={{ fontFamily: "'Staatliches', cursive" }}>
              Benvenuti alla<br />
              <span className="text-amber-600">Bottega dei Briganti</span>
            </h2>

            <div className="space-y-6 text-slate-700 text-lg leading-relaxed mb-10">
              <p>
                <strong className="text-slate-900">Siamo un'hamburgeria</strong>, le nostre materie prime vengono per lo più da realtà locali: 
                le nostre carni non provengono da allevamenti intensivi e la ricetta dei nostri hamburger è creata da noi, 
                utilizzando tagli selezionati e mirati.
              </p>
              
              <p>
                Il pane viene sfornato quotidianamente e contiene una percentuale di farina di Teff, 
                perciò è a basso contenuto di glutine, sempre croccante fuori e morbido all'interno.
              </p>
              
              <p>
                Le nostre verdure sono sempre fresche e nei mesi estivi utilizziamo prodotti dell'orto. 
                Le birre provengono per la maggior parte da birrifici artigianali che lavorano sul nostro territorio.
              </p>
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="tel:0522886705">
                <Button
                  size="lg"
                  className="bg-amber-600 hover:bg-amber-700 text-white font-bold px-8 py-6 shadow-xl hover:scale-105 transition-all duration-300"
                  style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}
                >
                  <Phone className="w-5 h-5 mr-2" />
                  ORDINA TAKEAWAY
                </Button>
              </a>
            </div>

            {/* Fun Fact */}
            <div className="mt-10 p-6 bg-amber-50 border-l-4 border-amber-600 rounded-r-lg">
              <p className="text-slate-800 italic">
                <span className="font-semibold not-italic">Ah sì...</span> siamo troppo simpatici! 😄
              </p>
            </div>
          </div>

          {/* Image Grid */}
          <div className="order-1 lg:order-2 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="relative h-64 rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src="https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/fkdza7rc_PHOTO-2022-05-25-14-45-53_2.jpeg"
                    alt="Burger Bottega"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="relative h-48 rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src="https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/30o8lrp6_PHOTO-2022-05-25-14-45-53.jpeg"
                    alt="Burger Gourmet"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="relative h-48 rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src="https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/ovlhu4a3_PHOTO-2022-05-25-14-45-53_3.jpeg"
                    alt="Burger Verdure"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="relative h-64 rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src="https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/zjs2u1sn_PHOTO-2022-05-25-14-45-54_2.jpeg"
                    alt="Burger Speciale"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
              </div>
            </div>
            
            {/* Decorative Element */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-amber-400 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
